import React, { useMemo } from 'react'

import type { DateStringProps } from '@fourthwall/components'
import { DateString } from '@fourthwall/components'

import { useShopTime } from '../providers/ShopTimeProvider'

export type TimezonedDateStringProps = DateStringProps & {
  withTimezoneAbbreviation?: boolean
}

const TIME_FORMAT_TOKENS = ['H', 'HH', 'h', 'hh', 'm', 'mm', 's', 'ss', 'A', 'a']

const hasTimeFormat = (format: string): boolean => {
  return TIME_FORMAT_TOKENS.some((token) => format.includes(token))
}

export const TimezonedDateString = ({
  date: originDate,
  format: originFormat = 'DD MMM YYYY',
  withTimezoneAbbreviation,
  ...props
}: TimezonedDateStringProps) => {
  const { timezoneAbbreviation, toShopTime } = useShopTime()

  const date = toShopTime(originDate)
  const shouldShowTimezone = useMemo(() => {
    if (typeof withTimezoneAbbreviation === 'boolean') {
      return withTimezoneAbbreviation
    }

    return hasTimeFormat(originFormat)
  }, [withTimezoneAbbreviation, originFormat])

  const format = useMemo(
    () => (shouldShowTimezone ? `${originFormat} ([${timezoneAbbreviation}])` : originFormat),
    [shouldShowTimezone, originFormat, timezoneAbbreviation],
  )

  return <DateString {...props} date={date} format={format} />
}
